const mortgage = (context) => context.mortgage || {};
const mortgageParts = (context) => context.mortgageParts || [];
const mortgageProperties = (context) => context.mortgageProperties || [];
const mortgagePartByIndex = (context) => (index) => context.mortgageParts[index] || [];

export default {
  mortgage,
  mortgageParts,
  mortgagePartByIndex,
  mortgageProperties,
};
